/** Map app lang code (e.g. en, hi) to BCP-47 for STT/TTS. */
export function resolveBcp47Lang(code?: string | null): string {
  const c = (code || 'en').trim().toLowerCase();
  if (c === 'en') return 'en-US';
  if (c === 'hi') return 'hi-IN';
  if (c === 'mr') return 'mr-IN';
  if (c.includes('-')) return c;
  return `${c}-${c.toUpperCase()}`;
}

/** Read targetedLang from localStorage when in browser. */
export function readTargetedLang(): string {
  if (typeof window === 'undefined' || !window.localStorage) return 'en';
  return localStorage.getItem('targetedLang') || 'en';
}
